<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <v-toolbar flat class="toolbar" dense justify="center">
                <v-toolbar-title align="center">
                    <router-link to="/" style="text-decoration: none;" title="Back">
                        <v-icon large color="white darken">mdi-chevron-left-circle</v-icon>
                    </router-link>
                    <strong> Quick Pay </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row dense justify="center">
                <v-col sm="2" md="2" cols="12">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="org" :items="org_list" item-text="name" return-object label="Organization" outlined @change="getPaymentType();getAy();clear()"></v-autocomplete>
                </v-col>
                <v-col sm="2" md="2" cols="12" v-if="academic_year_list!=''">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="ay" :items="academic_year_list" item-text="ay" return-object label="Academic Year" outlined @change="clear()"></v-autocomplete>
                </v-col>
                <v-col sm="2" md="2" cols="12" v-if="payment_type_list!=''">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="payment_type" :items="payment_type_list" item-text="name" item-value="id" label="Payment Type" outlined @change="clear()"></v-autocomplete>
                </v-col>
                <v-col sm="2" md="2" cols="12">
                    <v-icon color="error">*</v-icon>
                    <v-text-field outlined rounded color="#0F2027" dense placeholder="Enter PRN No" v-model="stud" type="text" hint="For example :: 121/111"></v-text-field>
                    <!-- <v-autocomplete rounded dense required v-model="stud" :items="stud_list" item-text="name" item-value="lid" label="Student" outlined @change="clear()"></v-autocomplete> -->
                </v-col>
                <v-col sm="2" v-if="payment_type && stud && ay && org">
                    <v-btn rounded class="button mt-6" @click="getPaymentDetails()" :loading="fetch_loader">Proceed</v-btn>
                </v-col>
            </v-row>
            <span v-if="paymenttype">
                <v-row justify="center" v-if="learner_info!=''">
                    <v-col cols="12" sm="12" md="12">
                        <v-toolbar dense class="toolbar" flat color="white">
                            <v-toolbar-title>Child Information</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </v-col>
                    <v-col cols="12" sm="3" md="3"><strong>Registration No. :</strong>{{ learner_info[0].reg_no }}</v-col>
                    <v-col cols="12" sm="3" md="3"><strong>Name :</strong>{{ learner_info[0].name }}</v-col>
                    <v-col cols="12" sm="3" md="3"><strong>Standard :</strong>{{ learner_info[0].learner_std }}</v-col>
                    <v-col cols="12" sm="3" md="3"><strong>Division :</strong>{{ learner_info[0].learner_div }}</v-col>
                </v-row>
                <v-row dense justify="center" v-if="paymenttype == 'MISC'">
                    <v-col sm="12" md="12" cols="12">
                        <v-row v-if="misc_fees_list != ''" dense justify="center">
                            <v-col sm="4" md="4">
                                <v-autocomplete
                                    clearable
                                    rounded
                                    outlined
                                    dense
                                    v-model="search_category"
                                    @change="selectAll = false"
                                    :items="misc_fees_list"
                                    item-text="miscfeescategory"
                                    label="Search Category"
                                    persistent-hint
                                    single-line
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row class="flash" v-else dense justify="center">
                            <strong>Misc fee not configure please contact admin of school</strong>
                        </v-row>
                        <v-simple-table dense class="elevation-1 mytable" v-if="feelist != '' && search_category != null">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th>
                                            <label class="form-checkbox">
                                                <input type="checkbox" v-model="selectAll" @click="select" />
                                                <i class="form-icon"></i>
                                            </label>
                                        </th>
                                        <th>Sr. No.</th>
                                        <th>Amount</th>
                                        <th>Misc</th>
                                        <th>Misc Category</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in feelist" :key="index">
                                        <td>
                                            <label class="form-checkbox">
                                                <input type="checkbox" :value="item.id" v-model="selected" />
                                                <i class="form-icon"></i>
                                            </label>
                                        </td>
                                        <td>{{ item.srno }}</td>
                                        <td>{{ item.amount }}</td>
                                        <td>{{ item.miscfeesmaster }}</td>
                                        <td>{{ item.miscfeescategory }}</td>
                                        <td>
                                            <span v-if="item.pay == false">
                                                <strong>Already Paid</strong>
                                            </span>
                                            <span v-else>
                                                <form :action="url" @submit="payment" name="paytmform" method="POST">
                                                    <input type="hidden" :value="item.orgid" name="orgid" />
                                                    <input type="hidden" :value="item.tenantid" name="tenantid" />
                                                    <input type="hidden" :value="item.uid" name="uid" />
                                                    <input type="hidden" :value="item.learner_id" name="studid" />
                                                    <input type="hidden" :value="item.amount" name="fee_amount" />
                                                    <input type="hidden" :value="item.ay" name="ay" />
                                                    <input type="hidden" :value="item.miscfeesmaster" name="purpose" />
                                                    <input type="hidden" :value="item.id" name="json_pre_trans_data" />
                                                    <input type="hidden" :value="item.hash_val" name="hash_val" />
                                                    <v-btn small class="button" type="submit" :loading="loader">Proceed</v-btn>
                                                </form>
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                        <center>
                            <v-btn small class="button" v-if="selected != '' && search_category != null" @click="getAmountDetails(selected)">Get Amount Details</v-btn>
                        </center>
                        <span v-if="show_details && selected != '' && search_category != null">
                            <center>
                                <span v-for="(s, index) in miscfeesmaster" :key="index">{{ index + 1 }}.{{ s }} <br /></span>
                            </center>
                            <center><strong> Total Amount - </strong>{{ amount }}</center>
                            <v-row justify="center">
                                <form :action="url" @submit="payment" name="paytmform" method="POST">
                                    <input type="hidden" :value="orgid" name="orgid" />
                                    <input type="hidden" :value="tenantid" name="tenantid" />
                                    <input type="hidden" :value="uid" name="uid" />
                                    <input type="hidden" :value="learner_id" name="studid" />
                                    <input type="hidden" :value="amount" name="fee_amount" />
                                    <input type="hidden" :value="ay_id" name="ay" />
                                    <input type="hidden" :value="miscfeesmaster" name="purpose" />
                                    <input type="hidden" :value="id" name="json_pre_trans_data" />
                                    <input type="hidden" :value="hash_val" name="hash_val" />
                                    <v-btn small class="button" type="submit" :loading="loader">Proceed</v-btn>
                                </form>
                            </v-row>
                        </span>
                    </v-col>
                </v-row>
                <v-row dense justify="center" v-else-if="paymenttype == 'INSTALLMENT'">
                    <v-col cols="12" sm="12" md="12" v-if="org_id == 'wws' || org_id=='vvp' || org_id == 'sanjivani' || org_id == 'sbpps' || org_id == 'zeal'">
                        <v-simple-table dense class="elevation-1 mytable">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th>
                                            Name
                                        </th>
                                        <th>
                                            Total Amount
                                        </th>
                                        <th>
                                            Paid Amount
                                        </th>
                                        <th>
                                            Remaining Amount
                                        </th>
                                        <th v-if="org_id == 'wws' || org_id == 'vvp'">
                                            Late Fee Charge (If Applicable)
                                        </th>
                                        <th>
                                            Amount To Pay
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item,index) in installment_details_list" :key="index">
                                        <td><strong>{{ item.name }}</strong></td>
                                        <td>{{ item.fee }}</td>
                                        <td>{{ item.paid_fee }}</td>
                                        <td>{{ item.balnace_fee }}</td>
                                        <td v-if="org_id == 'wws' || org_id == 'vvp'">
                                            {{ item.fine }} Rs. between {{ item.due_date }}. <span v-if="item.due_date_variable_fine && item.variable_fine != 0"> Daily {{item.variable_fine}} Rs. after {{item.due_date_variable_fine}}</span>
                                        </td>
                                        <td v-if="item.balnace_fee > 0"><strong>{{ item.balnace_fee + item.fine_due_date}}</strong></td>
                                        <td v-else><strong>{{ item.balnace_fee}}</strong></td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                        <!-- <v-row justify="center">
                            <span v-for="(inst,index) in installment_list" :key="index">
                                <input type="hidden" :value="index + 1" />
                                <input type="radio" class="radiospace" v-model="inst_id" v-bind:value="inst" @change="getInstAmountDetails();" />
                                {{inst.name}}
                            </span>
                        </v-row> -->
                        <v-row justify="center" v-if="installment_list.length > 0">
                    <v-col cols="12" sm="4" md="4">
                        <v-autocomplete
                            color="#0F2027"
                            dense
                            rounded
                            multiple
                            required
                            v-model="inst_id"
                            return-object
                            :items="installment_list"
                            item-text="name"
                            label="Select Installments"
                            outlined
                            persistent-hint
                            hint="Please Select installments"
                        />
                        <!-- {{inst_id}} -->
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-btn
                            class="button"
                            @click="
                getInstAmountDetails();
              "
                        >
                            Get Fee Details
                        </v-btn>
                    </v-col>
                </v-row>
                        <v-row v-if="matrix_list!=''">
                            <v-col cols="12" sm="12" md="12">
                                <v-simple-table dense class="elevation-1 mytable">
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th>
                                                    Fees Component
                                                </th>
                                                <th>
                                                    Total Amount
                                                </th>
                                                <th>
                                                    Paid Amount
                                                </th>
                                                <th>
                                                    Remaining Amount
                                                </th>
                                                <th>
                                                    Amount To Pay
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in matrix_list" :key="item.lid">
                                                <td>{{ item.feescomponentacademicyear }}</td>
                                                <td>{{ item.amount }}</td>
                                                <td>{{ item.paid_till_now }}</td>
                                                <td>{{ item.reamining }}</td>
                                                <td>{{ item.amount_pay }}</td>
                                            </tr>
                                            <tr class="toolbar noborder">
                                                <td class="noborder toolbar"></td>
                                                <td class="noborder toolbar"></td>
                                                <td class="noborder toolbar"></td>
                                                <td class="noborder toolbar"><span v-if="total_amount != 0">Late Fee Charge :: {{fine}} </span></td>
                                                <td class="noborder toolbar">Total Amount To Pay :: {{total_amount}}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-col>
                            <v-col cols="12" sm="12" md="12"></v-col>
                        </v-row>
                        <v-row v-if="matrix_list!=''" justify="center">
                            <v-col cols="12" sm="2" md="2">
                                <span class="text-color1">Total Fees :: {{fees_amount}}</span>
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                                <span class="text-color2">Paid Fees :: {{paid_amount}}</span>
                            </v-col>
                            <v-col cols="12" sm="2" md="2" v-if="total_amount != 0">
                                <span class="text-color">Late Fee Charge :: {{fine}}</span>
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                                <span class="text-color">Remaining Fees :: {{total_amount}}</span>
                            </v-col>
                        </v-row>
                        <span class="flash" v-if="matrix_list!='' && total_amount!=0">
                            <strong><center>Please do not REFRESH or CLOSE ERP page at the time of transaction</center></strong>
                        </span>
                        <v-row justify="center" v-if="matrix_list!=''">
                            <form :action="inst_url" v-if="pg_hidden!=null && pgs.includes('PayTM')" @submit="payment" name="paytmform" method="POST">
                                <input type="hidden" :value="pg_hidden.orgid" name="orgid" />
                                <input type="hidden" :value="pg_hidden.tenantid" name="tenantid" />
                                <input type="hidden" :value="pg_hidden.uid" name="uid" />
                                <input type="hidden" :value="pg_hidden.studid" name="studid" />
                                <input type="hidden" :value="pg_hidden.ay" name="ay" />
                                <input type="hidden" :value="total_amount" name="fee_amount" />
                                <input type="hidden" :value="inst_id.name" name="purpose" />
                                <input type="hidden" :value="matrix_pg_list" name="json_pre_trans_data" />
                                <input type="hidden" :value="pg_hidden.hash_val" name="hash_val" />
                                <v-btn class="button" :loading="pg_loader" v-if="total_amount!=0" type="submit">Pay Online [PayTM]</v-btn>
                            </form>
                            <form :action="billdesk_url" v-if="pg_hidden != null && pgs.includes('Bill-Desk')" @submit="payment" name="paytmform" method="POST">
                                <input type="hidden" :value="pg_hidden.orgid" name="orgid" />
                                <input type="hidden" :value="pg_hidden.tenantid" name="tenantid" />
                                <input type="hidden" :value="pg_hidden.uid" name="uid" />
                                <input type="hidden" :value="pg_hidden.studid" name="studid" />
                                <input type="hidden" :value="pg_hidden.ay" name="ay" />
                                <input type="hidden" :value="total_amount" name="fee_amount" />
                                <input type="hidden" :value="inst_id.name" name="purpose" />
                                <input type="hidden" :value="matrix_pg_list" name="json_pre_trans_data" />
                                <input type="hidden" :value="pg_hidden.hash_val" name="hash_val" />
                                <v-btn class="button" :loading="pg_loader" v-if="total_amount != 0" type="submit">Pay Online [Bill-Desk]</v-btn>
                            </form>
                            <form :action="easebuzz_url" v-if="pg_hidden != null && pgs.includes('EaseBuzz')" @submit="payment" name="paytmform" method="POST">
                                <input type="hidden" :value="pg_hidden.orgid" name="orgid" />
                                <input type="hidden" :value="pg_hidden.tenantid" name="tenantid" />
                                <input type="hidden" :value="pg_hidden.uid" name="uid" />
                                <input type="hidden" :value="pg_hidden.studid" name="studid" />
                                <input type="hidden" :value="pg_hidden.ay" name="ay" />
                                <input type="hidden" :value="total_amount" name="fee_amount" />
                                <input type="hidden" :value="inst_id.name" name="purpose" />
                                <input type="hidden" :value="matrix_pg_list" name="json_pre_trans_data" />
                                <input type="hidden" :value="pg_hidden.hash_val" name="hash_val" />
                                <v-btn class="button" :loading="pg_loader" v-if="total_amount != 0" type="submit">Pay Online [EaseBuzz]</v-btn>
                            </form>
                            <form :action="razorpay_url" v-if="pg_hidden != null && pgs.includes('RAZORPAY')" @submit="payment" name="paytmform" method="POST">
                                <input type="hidden" :value="pg_hidden.orgid" name="orgid" />
                                <input type="hidden" :value="pg_hidden.tenantid" name="tenantid" />
                                <input type="hidden" :value="pg_hidden.uid" name="uid" />
                                <input type="hidden" :value="pg_hidden.studid" name="studid" />
                                <input type="hidden" :value="pg_hidden.ay" name="ay" />
                                <input type="hidden" :value="total_amount" name="fee_amount" />
                                <input type="hidden" :value="inst_id.name" name="purpose" />
                                <input type="hidden" :value="matrix_pg_list" name="json_pre_trans_data" />
                                <input type="hidden" :value="pg_hidden.hash_val" name="hash_val" />
                                <input type="hidden" value="INSTALLMENT" name="payment_type" />
                                <v-btn class="button" :loading="pg_loader" v-if="total_amount != 0" type="submit">Pay Online [RAZORPAY]</v-btn>
                            </form>
                        </v-row>
                        <span v-if="matrix_list!='' && total_amount!=0">
                            <strong><center>Standard charges will apply, based on Mode of Payment</center></strong>
                        </span>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" v-else>
                        <v-data-table v-if="student_invoice_list!=''" :items="student_invoice_list" :headers="headers_invoice" class="elevation-1 mytable" dense :search="search">
                            <template v-slot:[`item.invoice_number`]="{ item }">
                                <v-tooltip top color="warning">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn class="pt-none mt-none" outlined rounded small color="warning" v-bind="attrs" v-on="on" @click="getData(item.id)">{{item.invoice_number}}</v-btn>
                                    </template>
                                    <span>
                                        Print Challan!!!
                                    </span>
                                </v-tooltip>
                            </template>
                            <template v-slot:[`item.pay`]="{ item }">
                                <div v-if="!item.is_paid">
                                    <form :action="installment_eazebuzz_url" @submit="payment" name="paytmform" method="POST">
                                        <input type="hidden" :value="item.org" name="orgid" />
                                        <input type="hidden" :value="item.academicyear_id" name="ay" />
                                        <input type="hidden" :value="item.tenantid" name="tenantid" />
                                        <input type="hidden" :value="item.uid" name="uid" />
                                        <input type="hidden" :value="item.stud_id" name="studid" />
                                        <input type="hidden" :value="item.total" name="fee_amount" />
                                        <input type="hidden" :value="item.id" name="json_pre_trans_data" />
                                        <!-- learner invoice id -->
                                        <input type="hidden" :value="item.hash_val" name="hash_val" />
                                        <v-btn small class="button" type="submit" :loading="loader" :disabled="item.pay_fee == 0">Pay</v-btn>
                                    </form>
                                </div>
                                <div v-else class="text">
                                    <strong>Already Paid</strong>
                                </div>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
                <v-row dense justify="center" v-else-if="paymenttype == 'CANTEEN'">
                    <v-col cols="12" sm="12" md="12">
                        <v-data-table v-if="learner_canteen_installments!=''" :headers="headers" dense class="elevation-1" :items="learner_canteen_installments">
                            <template v-slot:top>
                                <v-toolbar flat dense class="toolbar">
                                    <v-toolbar-title>Canteen-Installment Details</v-toolbar-title>
                                    <v-divider class="mx-4" inset vertical></v-divider>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                            </template>
                            <template v-slot:[`item.is_approved`]="{ item }">
                                <span v-if="item.is_approved">
                                    <span v-if="item.amount_to_pay <= 0">
                                        <strong>Already Paid</strong>
                                    </span>
                                    <span v-else>
                                        <form :action="canteen_url" @submit="payment" name="paytmform" method="POST">
                                            <input type="hidden" :value="item.orgid" name="orgid" />
                                            <input type="hidden" :value="item.tenantid" name="tenantid" />
                                            <input type="hidden" :value="item.uid" name="uid" />
                                            <input type="hidden" :value="item.learner_id" name="studid" />
                                            <input type="hidden" :value="item.amount_to_pay" name="fee_amount" />
                                            <input type="hidden" :value="item.ay" name="ay" />
                                            <input type="hidden" :value="item.name" name="purpose" />
                                            <input type="hidden" :value="item.learner_canteen_fees_installment_id" name="learner_canteen_fees_installment_id" />
                                            <input type="hidden" :value="item.learner_canteen_fees_installment_id" name="json_pre_trans_data" />
                                            <input type="hidden" :value="item.hash_val" name="hash_val" />
                                            <input type="hidden" value="Create" name="flag" />
                                            <v-btn small color="warning" type="submit" :loading="loader">Pay</v-btn>
                                        </form>
                                    </span>
                                </span>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
                <v-row dense justify="center" v-else>
                    <strong class="flash">Under Development....</strong>
                </v-row>
                <v-dialog v-model="dialog_challan" style="margin-top: 10%;" max-width="900px">
                    <v-card class="mx-auto">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>Invoice Details</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-toolbar-items>
                                <v-btn dark text @click="dialog_challan = false"><v-icon>mdi-close</v-icon>Close</v-btn>
                            </v-toolbar-items>
                        </v-toolbar>
                        <v-card-title>
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <br />
                        <v-card-text v-if="learner_challan_data!=''">
                            <div class="main" v-if="learner_challan_data != null" style="border: 1px solid black; max-width: 800px; margin: auto;">
                                <v-col cols="12" sm="12" md="12">
                                    <div style="text-align: center; margin-top: -10px;">
                                        <img :src="org_basic_data.trust_logo" width="140px" alt="logo" />
                                    </div>
                                    <div style="text-align: center; margin-top: -10px;">
                                        Fee Invoice | {{ learner_challan_data.feesinstallmentacademicyear }} | {{ learner_challan_data.ay }}
                                    </div>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                    <v-simple-table dense style="margin-top: -15px;">
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <td colspan="3" class="text-left" style="border-right: none; border-bottom: none;"><strong>Name : </strong>{{ learner_challan_data.name }}</td>
                                                    <td colspan="3" class="text-left" style="border-left: none; border-bottom: none;"><strong>Academic Year :</strong> {{ learner_challan_data.ay }}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="3" class="text-left" style="border-right: none; border-bottom: none; border-top: none;">
                                                        <strong>Grade :</strong> {{ learner_challan_data.standard }} ({{ learner_challan_data.quota }})
                                                    </td>
                                                    <td colspan="3" class="text-left" style="border-left: none; border-bottom: none; border-top: none;"><strong>Invoice Date :</strong> {{ learner_challan_data.invoice_date }}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="3" class="text-left" style="border-right: none; border-bottom: none; border-top: none;"><strong>Parent's Name :</strong> {{ learner_challan_data.parent_name }}</td>
                                                    <td colspan="3" class="text-left" style="border-left: none; border-bottom: none; border-top: none;"><strong>Due Date :</strong> {{ learner_challan_data.due_date }}</td>
                                                </tr>

                                                <tr>
                                                    <th style="text-align: center; color: black;">Sr.No</th>
                                                    <th style="text-align: center; color: black;">Head</th>
                                                    <th style="text-align: center; color: black;">Term Due</th>
                                                    <th style="text-align: center; color: black;">Waiver</th>
                                                    <th style="text-align: center; color: black;">Due Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, index) in learner_challan_data.student_invoice_details" :key="index">
                                                    <td>{{ item.srno }}</td>
                                                    <td>{{ item.component }}</td>
                                                    <td>{{ item.amount }}</td>
                                                    <td>{{ item.waived_amount }}</td>
                                                    <td>{{ item.due_amount }}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="4" style="text-align: center; font-weight: bolder; text-transform: uppercase;">Total Due Amount</td>
                                                    <td>{{ learner_challan_data.total_fees_amount }}</td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-col>
                                <div class="main">
                                    <v-col cols="12" sm="12" md="12">
                                        <v-simple-table dense>
                                            <template v-slot:default>
                                                <tr>
                                                    <td style="text-align: center;"><strong>Amount in words : </strong>{{ learner_challan_data.amount_in_words }}</td>
                                                </tr>
                                            </template>
                                        </v-simple-table>
                                    </v-col>
                                    <div>
                                        <div>
                                            <p style="font-size: small; margin-bottom: -0.5px;">
                                                <b>Policy :</b><br />
                                                <b>OTHER TERMS AND CONDITIONS :</b> <br />
                                                <b>FEE PAYMENT SCHEDULE </b><br />
                                                Parents are responsible to ensure that the fee is paid by the due date as per the following schedule.
                                            </p>
                                        </div>
                                    </div>
                                    <v-simple-table dense>
                                        <thead>
                                            <tr>
                                                <th style="text-align: center; color: black;">Installment</th>
                                                <th style="text-align: center; color: black;">Due Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in installments_details" :key="index">
                                                <td>{{ item.name }}</td>
                                                <td>{{ item.due_date }}</td>
                                            </tr>
                                        </tbody>
                                    </v-simple-table>
                                </div>
                                <div style="display: flex; padding-left: 17px; margin-top: 5px;">
                                    <div style="flex-direction: column;">
                                        <p style="font-size: small;">
                                            <b>Payment Mode Options:</b><br />
                                            A Cheque/Demand draft may be given in favor of :<br />
                                            <b style="text-transform: uppercase;">{{learner_challan_data.in_favour_of}}</b><br />
                                            Payment may be done through NEFT/RTGS as per the<br />
                                            following bank details. <b> Beneficiary Name:</b><br />
                                            <b style="text-transform: uppercase;">{{learner_challan_data.beneficiary_name}}</b><br />
                                            <b>Bank Name:</b> {{learner_challan_data.bank_name}}<br />
                                            <b>Account Holder Name:</b> {{learner_challan_data.in_favour_of}} <br />
                                            <b>Account No.</b> {{learner_challan_data.account_no}}<br />
                                            <b>Account Type:</b> {{learner_challan_data.account_type}}<br />
                                            <b>IFSC Code:</b> {{learner_challan_data.ifsc_code}}<br />
                                            <b>Swift Code (for international transfers):</b> KKBKINBB <br />
                                            <b>Branch:</b> {{learner_challan_data.bank_branch}}<br />
                                        </p>
                                    </div>
                                    <div style="border-style: solid; border-width: 3px; padding-top: 5px; margin-top: 15px; width: 35%; text-align: center; margin-left: 52px; font-size: medium; height: 35vh;">
                                        <b> QR code </b><br />
                                        <b> Universal Wisdom School </b><br />
                                        <br />
                                        <div>
                                            <img :src="learner_challan_data.qrcode_path" alt="QR code" width="120" height="120" />
                                        </div>
                                    </div>
                                    <br />
                                </div>
                                <p style="font-size: small; padding-left: 17px;">
                                    <b>Please Note:</b><br />
                                    Fee paid after the due date will attract a late payment penalty at a rate of Rs. 500 per day. NonPayment of Fee for aperiod of 30 days after the due date shall automatically result in cancellation of the
                                    student’s name from the class list. A re-enrollment fee will be charged if the child wishes to continue after cancellation of the enrollment. There will be a penalty of Rs. 1000/- on dishonoured cheques.
                                    No withdrawals are permitted in the middle of the term. In case of unavoidable situations where withdrawing the student is imperative, a notice period of a minimum of 3 months is required to be submitted
                                    to the School. No refund can be claimed from the school in case of Mid-Term withdrawal.
                                </p>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </span>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                loader: false,
                overlay: false,
                color: "",
                snackbar: false,
                search: null,
                snackbar_msg: null,
                org_list: null,
                display_data: false,
                org: "",
                org_id: null,
                academic_year_list: [],
                ay: null,
                org_data_list: [],
                dialog: false,
                org_data: [],
                dns: null,
                stud: null,
                payment_type: null,
                payment_type_list: [],
                stud_list: [],
                stud: null,
                paymenttype: null,
                misc_fees_list: [],
                search_category: null,
                selectAll: false,
                selectedTasks: [],
                selected: [],
                ay_id: null,
                amount: null,
                id: null,
                miscfeesmaster: null,
                learner_div_id: null,
                learner_id: null,
                tenantid: null,
                orgid: null,
                hash_val: null,
                uid: null,
                show_details: false,
                url: "",
                inst_url: "",
                billdesk_url: "",
                easebuzz_url: "",
                razorpay_url: "",
                url_multiple: "",
                canteen_url: "",
                installment_eazebuzz_url: "",
                fetch_loader: false,
                installment_details_list: [],
                installment_list: [],
                inst_id: null,
                pg_hidden: null,
                matrix_list: [],
                total_amount: null,
                paid_amount: null,
                fees_amount: null,
                fine: null,
                matrix_pg_list: null,
                pgs: [],
                pg_loader: false,
                learner_canteen_installments: [],
                student_invoice_list: [],
                learner_challan_data: [],
                org_basic_data: [],
                installments_details: [],
                dialog_challan: false,
                learner_info: [],
                headers: [
                    { text: "Sr No", value: "srno" },
                    { text: "Installment", value: "name" },
                    { text: "Applied Date", value: "applied_date" },
                    { text: "Ends On", value: "to_date" },
                    { text: "Amount", value: "amount" },
                    { text: "Applied For", value: "canteenmenutype" },
                    { text: "Paid Till Now", value: "paid_till_now" },
                    { text: "Payment", value: "is_approved" },
                ],
                headers_invoice: [
                    { text: "Invoice No", value: "invoice_number", sortable: true },
                    { text: "Student", value: "learner", sortable: true },
                    { text: "Invoice Date", value: "invoice_date", sortable: true },
                    { text: "Installment", value: "feesinstallmentacademicyear", sortable: true },
                    { text: "Amount", value: "total", sortable: true },
                    { text: "Pay", value: "pay", sortable: true },
                ],
            };
        },
        computed: {
            feelist() {
                function compare(a, b) {
                    if (a.name < b.name) return -1;
                    if (a.name > b.name) return 1;
                    return 0;
                }
                if (!this.search_category) return this.misc_fees_list.sort(compare);
                return this.misc_fees_list.filter((tbdata) => {
                    return tbdata.miscfeescategory.toLowerCase().indexOf(this.search_category.toLowerCase()) >= 0;
                });
            },
        },
        created() {
            this.url = process.env.VUE_APP_API_URL + "/paymentGatewayPayTM/paytm_misc";
            this.inst_url = process.env.VUE_APP_API_URL + "/paymentGatewayPayTM/paytm";
            this.billdesk_url = process.env.VUE_APP_BD_URL + "/paymentGatewayBillDesk/billdesk";
            this.easebuzz_url = process.env.VUE_APP_API_URL + "/PaymentGatewayEaseBuzz/easebuzz";
            this.razorpay_url = process.env.VUE_APP_API_URL + "/PayementGatewayzRazorPay/razorPayInitiate";
            this.canteen_url = process.env.VUE_APP_API_URL + "/paymentGatewayPayTM/paytm_canteen";
            this.installment_eazebuzz_url = process.env.VUE_APP_API_URL + "/PaymentGatewayEaseBuzz/easebuzzinvoicepayment";
        },
        methods: {
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getPaymentType() {
                (this.payment_type_list = []), (this.payment_type = null);
                this.payment_type_list = this.org.payment_type;
            },
            getAy() {
                (this.academic_year_list = []), (this.ay = null);
                this.academic_year_list = this.org.ay_list;
                this.ay = this.org.curr_ay;
            },
            // getStudent() {
            //     (this.stud_list = []), (this.stud = null);
            //     this.stud_list = this.org.stud_list;
            // },
            payment() {
                var formData = new FormData(paytmform);
                console.log("formData");
                console.log(formData);
                this.loader = false;
                this.pg_loader = false;
            },
            async getData(challan_no) {
                this.learner_challan_data = [];
                const formData = {
                    challan_no: challan_no,
                    stud: this.stud,
                    ay: this.ay.id,
                };
                try {
                    const res = await axios.post("/AccountingAndFees/getInvoicetDetails", formData);
                    if (res.data.flag == "YES") {
                        this.learner_challan_data = res.data.student_challan_details;
                        this.org_basic_data = res.data.org_basic_data;
                        this.installments_details = res.data.installments_details;
                        this.dialog_challan = true;
                    } else if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.snackbar);
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                } catch (err) {
                    this.showSnackbar("#b71c1c", "Something went wrong!");
                } finally {
                }
            },
            async getInstAmountDetails() {
                this.pg_hidden = [];
                this.matrix_list = [];
                this.total_amount = null;
                this.paid_amount = null;
                this.fees_amount = null;
                this.fine = null;
                this.matrix_pg_list = [];
                const data = {
                    stud: this.stud,
                    ay: this.ay.id,
                    inst_id: this.inst_id,
                    org: this.org.id,
                    dns: this.dns,
                };
                try {
                    const res = await axios.post("/AccountingAndFees/getInstAmountDetails", data);
                    if (res.data.flag == "YES") {
                        this.pg_hidden = res.data.pg_hidden;
                        this.matrix_list = res.data.matrix_list;
                        this.total_amount = res.data.total_amount;
                        this.paid_amount = res.data.paid_amount;
                        this.fees_amount = res.data.fees_amount;
                        this.fine = res.data.fine;
                        this.matrix_pg_list = JSON.stringify(this.pg_hidden.json_pre_trans_data);
                    } else if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.snackbar);
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                } catch (err) {
                    this.showSnackbar("#b71c1c", "Something went wrong!");
                } finally {
                }
            },
            async getAmountDetails(selectedTasks) {
                this.ay_id = null;
                this.id = null;
                this.amount = null;
                this.miscfeesmaster = null;
                this.learner_div_id = null;
                this.learner_id = null;
                this.tenantid = null;
                this.orgid = null;
                this.hash_val = null;
                this.uid = null;
                this.show_details = false;
                const data = {
                    stud: this.stud,
                    ay: this.ay.id,
                    selectedTasks: selectedTasks,
                    org: this.org.id,
                    dns: this.dns,
                };
                try {
                    const res = await axios.post("/AccountingAndFees/getMiscAmountDetails", data);
                    if (res.data.flag == "YES") {
                        this.ay_id = res.data.ay;
                        this.id = res.data.id;
                        this.amount = res.data.amount;
                        this.miscfeesmaster = res.data.miscfeesmaster;
                        this.learner_div_id = res.data.learner_div_id;
                        this.learner_id = res.data.learner_id;
                        this.tenantid = res.data.tenantid;
                        this.orgid = res.data.orgid;
                        this.hash_val = res.data.hash_val;
                        this.uid = res.data.uid;
                        this.show_details = true;
                    } else if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.snackbar);
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                } catch (err) {
                    this.showSnackbar("#b71c1c", "Something went wrong!");
                } finally {
                }
            },
            clear() {
                this.paymenttype = null;
                this.misc_fees_list = [];
                this.installment_details_list = [];
                this.installment_list = [];
                this.pgs = [];
                this.learner_canteen_installments = [];
                this.student_invoice_list = [];
                this.matrix_list = [];
                this.inst_id = null;
            },
            async getPaymentDetails() {
                this.paymenttype = null;
                this.misc_fees_list = [];
                this.installment_details_list = [];
                this.installment_list = [];
                this.pgs = [];
                this.learner_canteen_installments = [];
                this.student_invoice_list = [];
                this.matrix_list = [];
                this.inst_id = null;
                this.fetch_loader = true;
                const data = {
                    stud: this.stud,
                    ay: this.ay.id,
                    payment_type: this.payment_type,
                    org: this.org.id,
                    dns: this.dns,
                };
                try {
                    const res = await axios.post("/AccountingAndFees/getPaymentDetails", data);
                    if (res.data.flag == "YES") {
                        this.paymenttype = res.data.payment_type;
                        this.misc_fees_list = res.data.misc_fees_list;
                        this.installment_details_list = res.data.installment_details_list;
                        this.installment_list = res.data.installment_list;
                        this.student_invoice_list = res.data.student_invoice_list;
                        this.pgs = res.data.pgs;
                        this.learner_canteen_installments = res.data.learner_canteen_installments;
                        this.learner_id = res.data.learner_info[0].s_id
                        // var remaining = { id: "null", name: "Remaining" };
                        // this.installment_list.push(remaining);
                        this.learner_info = res.data.learner_info;
                        this.fetch_loader = false;
                    } else if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.snackbar);
                        this.fetch_loader = false;
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                        this.fetch_loader = false;
                    }
                } catch (err) {
                    this.showSnackbar("#b71c1c", "Something went wrong!");
                    this.fetch_loader = false;
                } finally {
                    this.fetch_loader = false;
                }
            },
            select() {
                this.miscfeesmaster = null;
                this.amount = null;
                this.selected = [];
                if (!this.selectAll) {
                    for (let i in this.feelist) {
                        this.selected.push(this.feelist[i].id);
                    }
                }
            },
            onload() {
                this.overlay = true;
                const data = {
                    dns: this.dns,
                };
                axios
                    .post("/AccountingAndFees/getOrgList", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.org_list = res.data.org_list;
                            this.org_id = res.data.tenantid;
                            console.log("org_id::::::::"+this.org_id)
                            this.overlay = false;
                        } else {
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                            this.overlay = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        //close loader
                    });
            },
        },
        mounted() {
            this.dns = window.location.hostname;
            console.log("dns:::::::::"+this.dns)
            this.onload();
        },
    };
</script>
<style scoped>
    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }
    .flash {
        animation-name: flash;
        animation-duration: 0.9s;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
        animation-direction: alternate;
        animation-play-state: running;
    }

    @keyframes flash {
        from {
            color: red;
        }
        to {
            color: white;
        }
    }
</style>
